import { useEffect } from 'react';
import AlmacenForm from '../../components/almacenes/AlmacenForm';
import { useAlmacenesStore, type RegistrarAlmacen } from '../../stores/almacenes/almacenes.store';

const AgregarAlmacen = () => {
  const { current: almacen, nuevo, registrar } = useAlmacenesStore((state) => state);

  useEffect(() => {
    nuevo();
  }, []);

  const handleSave = (values: RegistrarAlmacen) => {
    return registrar(values);
  };

  return <AlmacenForm esAgregar={true} almacen={almacen} onSave={handleSave} />;
};

export default AgregarAlmacen;
